import { executeClient } from "api/rage";
import { favouriteAnimations } from "store/animationsMenu";

export const playAnimation = (key) => {
    executeClient("e-dev.animations.play_animation", key);
}

export const setFavourite = (key) => {
    executeClient("e-dev.animations.set_favourite", key);
}

export const buyAnimation = (key) => {
    executeClient("e-dev.animations.buy_animation", key);
}

export const bindSlot = (slot, key) => {
    executeClient("e-dev.animations.bind", slot, key);
}

export const unbindSlot = (slot) => {
    executeClient("e-dev.animations.unbind", slot);
}